/**
 * Tag theme
 * @see https://github.com/chakra-ui/chakra-ui/blob/v2/packages/theme/src/components/tag.ts
 */
import { tagAnatomy as parts } from '@chakra-ui/anatomy';
export const Tag = {
    parts: parts.keys,
    baseStyle() {
        return {};
    },
    variants: {
        highlight: {
            container: {
                display: 'flex',
                padding: '0px 8px',
                justifyContent: 'center',
                alignItems: 'center',
                gap: '10px',
                borderRadius: '4px',
                color: 'brand.black',
                background: 'gradients.green-purple-horizontal',
                fontSize: '10px',
                fontWeight: 700,
                lineHeight: '16px',
                outline: '0px',
                minHeight: '20px',
            },
        },
        ecosystem: {
            container: {
                position: 'relative',
                display: 'flex',
                padding: '0px 8px',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: '4px',
                fontSize: '10px',
                fontWeight: 700,
                lineHeight: '16px',
                background: 'gradients.blue-green-horizontal',
                color: 'transparent',
                backgroundClip: 'text',
                overflow: 'hidden',
                _before: {
                    display: 'inline-block',
                    content: "''",
                    background: 'brand.gray-scale-border-10',
                    position: 'absolute',
                    inset: 0,
                },
            },
        },
    },
    sizes: {},
    defaultProps: {
        variant: 'custom',
    },
};
